// extracted by css-extract-rspack-plugin
module.exports =  {"flex":"JobManagement__flex___D9aIw","root":"JobManagement__root___R3Fiz JobManagement__flex___D9aIw","content":"JobManagement__content___v24ou JobManagement__flex___D9aIw"};